import React from 'react';
import {registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import Tooltip from '@mui/material/Tooltip';

/**
 * This brick displays a clickable loading icon.
 */
export default class LoaderButton extends ReactBrick {
    /**
     * @override
     */
    static getReactComponent($) {
        return () => {
            const isLoading = useProperty($, 'Loading');
            const tooltipText = useProperty($, 'Tooltip text');

            const handleClick = () => {
                $.trigger('On Click');
            };

            return (
                <Tooltip title={tooltipText} placement="top" enterDelay={700} leaveDelay={0}>
                    <div className="loading-icon-container">
                        <div
                            data-cy={'loader-button'}
                            className={`loading-icon ${isLoading ? 'loading' : ''}`}
                            onClick={handleClick}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={18}
                                height={18}
                                viewBox={`0 0 24 24`}
                                fill="none"
                                stroke="#9E9D9EFF"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
                                <path d="M21 3v5h-5" />
                            </svg>
                        </div>
                    </div>
                </Tooltip>
            );
        };
    }
}

registerBrick('0198bc9c03b04cd38b87', LoaderButton);
